import React, { ReactNode, useState } from "react";
import TopMenu from "./TopMenu";
import SETTINGS from "../globals";
import AppSections from "../utils/AppSections";
import { useNavigate } from "react-router-dom";
import DialogWindow from "./common/dialog_window/DialogWindow";
import DialogWindowType from "./common/dialog_window/DialogWindowType";
import EmbeddingToolInfo from "../utils/EmbeddingToolInfo";

interface IAnonymousProps {
  children: ReactNode;
}

function Anonymous({ children }: IAnonymousProps) {
  // reference to the navigator
  const navigate = useNavigate();

  // cookies acceptance
  const cookiesAcceptedOn = new Date();
  cookiesAcceptedOn.setTime(
    parseInt(localStorage.getItem("cookies-accepted-on") ?? "0"),
  );
  const [cookiesAcceptanceStillValid, setCookiesAcceptanceStillValid] =
    useState<boolean>(
      EmbeddingToolInfo.isChemiTool() ||
        (new Date().getTime() - cookiesAcceptedOn.getTime()) / 1000 <
          24 * 60 * 60,
    );

  return (
    <div>
      <TopMenu />
      <div className="mt-24">
        <div className={"p-4 pb-24 "}>{children}</div>
      </div>
      <div className="mb-10">
        <a
          onClick={() =>
            navigate(
              SETTINGS.get_path({
                section: AppSections.TERMS_AND_CONDITIONS,
              }),
            )
          }
          className="inline-block cursor-pointer hover:to-blue-600"
        >
          Terms and Conditions
        </a>
        {" | "}
        <a
          onClick={() =>
            navigate(
              SETTINGS.get_path({
                section: AppSections.COMMUNITY_RULES,
              }),
            )
          }
          className="inline-block cursor-pointer hover:to-blue-600"
        >
          Community Rules
        </a>
        {" | "}
        <a
          onClick={() =>
            navigate(
              SETTINGS.get_path({
                section: AppSections.LICENSE_AGREEMENT,
              }),
            )
          }
          className="inline-block cursor-pointer hover:to-blue-600"
        >
          Licensing Agreement
        </a>
      </div>
      {!cookiesAcceptanceStillValid && (
        <DialogWindow
          type={DialogWindowType.INFO}
          message="ChemiNova Portal is storing on your device the minimum information required for proper functioning. By continuing the use of the application, you agree with these terms."
          onConfirm={() => {
            localStorage.setItem(
              "cookies-accepted-on",
              new Date().getTime().toString(),
            );
            setCookiesAcceptanceStillValid(true);
          }}
          confirmLabel="I agree"
        />
      )}
    </div>
  );
}

export default Anonymous;
